import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-shared-address',
  templateUrl: './shared-address.component.html',
  styleUrls: ['./shared-address.component.css']
})
export class SharedAddressComponent implements OnInit {

  addressLocation
  @Input() adressType: string;
  @Input() LatLng = {}
  @Input() strictBounds: boolean
  @Input() title: boolean

  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;
  addr
    = {
      googleAddress: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
      streetAddress: '',
      location: '',
      suite_no: ''


    }
  autocompleteInput: string;
  queryWait: boolean;
  defaultBounds
  boundsLimit = true
  addressMain: FormGroup
  constructor(private changeDet: ChangeDetectorRef) { }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }


  // ngOnChanges(changes: SimpleChanges) {


  //   if (changes['strictBounds']['previousValue'] != undefined) {
  //     console.log(changes, 'changes')
  //     this.getPlaceAutocomplete();
  //   }
  // }



  private getPlaceAutocomplete() {
    let center: any = { lat: this.LatLng['lat'], lng: this.LatLng['lng'] };

    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1,
    };
    const options = {
      bounds: defaultBounds,
      radius: '10000000',
      strictBounds: this.boundsLimit,
    }
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, options)
    // {
    //     componentRestrictions: { country: 'US' },
    //     types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
    // });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();

      this.AddressChange(place)
      this.changeDet.detectChanges();


    });
  }

  invokeEvent() {
    this.setAddress.emit(this.addr)
  }






  limitCheckbox(e) {
    if (e.target.checked) {
      this.boundsLimit = true

    }
    else if (!e.target.checked) {
      this.boundsLimit = false
    }
    this.getPlaceAutocomplete();

  }


  addAddress() {

  }


  AddressChange(address: any) {
    this.addr['streetAddress'] = address.formatted_address;
    this.addr['address_contact_no'] = address.formatted_phone_number;
    this.addr['address_alternateContact_no'] = '';
    this.addr['googleAddress'] = address.name;
    var latitude = address.geometry.location.lat();
    var longitude = address.geometry.location.lng();
    this.addressLocation = { "type": "Point", "coordinates": [latitude, longitude] },
      this.addr['location'] = this.addressLocation;
    let address_components = address.address_components;
    for (let i = 0; i < address_components.length; i++) {
      console.log(address_components[i].types[0])
      if (address_components[i].types[0] == 'administrative_area_level_2') {
        this.addr['city'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'administrative_area_level_1') {
        this.addr['state'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'country') {
        this.addr['country'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'postal_code') {
        this.addr['postalCode'] = address_components[i].long_name || '';
      }
    }



  }



}
